import { t } from "@/i18n";

// Google değerlendirme çağrısı — header'ın üst ortasında duran tek satırlık rozet.
//
// Menünün SONUNDAYDI: "işini bitiren müşteri" mantığıyla doğruydu ama pratikte oraya kimse
// inmiyor. Üste alındı; büyük kart denendiğinde de ilk ekranın yarısını yiyip kategorileri
// katlamanın altına itti. Müşteri menüyü görmek için açıyor, önce menüyü görmeli — o yüzden
// çip diliyle tek satır. Sağ kenardaki dikey sekme de aynı sebeple bırakıldı: yer kaplamıyordu
// ama kenar süsü gibi durup fark edilmiyordu.
//
// Yıldız YOK: Google'ın yorum adresi puan parametresi kabul etmiyor, yani çizilen yıldız hiçbir
// şey yapmıyordu. Tıklanabilir gibi duran ama puanı taşımayan bir kontrol müşteriye yalan söyler.
export default function ReviewCard({ lang, url, onOpen }) {
  if (!url) {
    return null;
  }

  return (
    <a
      className="review-strip"
      href={url}
      target="_blank"
      rel="noreferrer"
      onClick={onOpen}
    >
      {t(lang, "review.cta")}
    </a>
  );
}
